import api from '@pray/shared/utils/api';

export async function createPushCampaign({
  artistId = undefined,
  name = undefined,
  status = undefined,
  scheduledAt = undefined,
  title = undefined,
  body = undefined,
  imageUrl = undefined,
  deeplink = undefined,
  presentation = undefined,
  badgeCount = undefined,
  audiences = undefined,
}) {
  if (!artistId) throw new Error('Artist ID is required');

  const data = {
    name,
    status,
    scheduled_at: scheduledAt,
    title,
    body,
    image_url: imageUrl,
    deeplink,
    presentation,
    badge_count: badgeCount,
    audiences,
  };

  const url = `/web/studio/artists/${artistId}/campaigns/push`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
